import { render, staticRenderFns } from "./DetailContentEdit.vue?vue&type=template&id=44433fd0&"
import script from "./DetailContentEdit.vue?vue&type=script&lang=js&"
export * from "./DetailContentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports